import { render, staticRenderFns } from "./OrderProfileCard.vue?vue&type=template&id=4b9bf639&scoped=true&"
import script from "./OrderProfileCard.vue?vue&type=script&lang=js&"
export * from "./OrderProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9bf639",
  null
  
)

export default component.exports